type Listener<T> = (data: T) => void;

export class EventEmitter<T> {
  private listeners: Listener<T>[] = [];

  subscribe(listener: Listener<T>) {
    this.listeners.push(listener);
    return () => {
      this.listeners = this.listeners.filter((l) => l !== listener);
    };
  }

  emit(data: T) {
    this.listeners.forEach((listener) => listener(data));
  }
}

export interface iFrameEvent {
  frame: ImageBitmap;
  timestamp: number;
}

export class ImageBitmapEventEmitter extends EventEmitter<iFrameEvent> {
  // Cache the latest ImageBitmap reference.
  private currentBitmap: ImageBitmap | null = null;
  private currentTimestamp: number | null = null;

  // Override emit so that it stores the latest ImageBitmap before notifying listeners.
  emit(data: iFrameEvent) {
    this.currentBitmap = data.frame;
    this.currentTimestamp = data.timestamp;
    super.emit(data);
  }

  // Access the most recent ImageBitmap (by reference).
  getCurrentBitmap(): ImageBitmap | null {
    return this.currentBitmap;
  }

  getCurrentTimestamp(): number | null {
    return this.currentTimestamp;
  }
}
